import { get, post } from "app/apis";
import MovingRoutes from "./MovingRoutes";

const MovingService = {
  getVehicle: async () => {
    const data = await get(MovingRoutes.getVehicle);
    return data;
  },
  createVehicle: async (obj) => {
    const data = await post(MovingRoutes.createVehicle, obj);
    return data;
  },
  deleteVehicle: async (obj) => {
    const data = await post(MovingRoutes.deleteVehicle, obj);
    return data;
  },
};

export default MovingService;
